/* eslint-disable */
/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-09 14:48:14
 * @LastEditors: yinj
 * @LastEditTime: 2021-02-24 17:03:29
 */
import Element from '../../components/core/models/element';
import { swapArray, getVM, eleRelativeBox, rgb2hex, sty2abbr } from '../../utils/element';
import elementApi from '@/services/modules/element'
import insertData from '@/utils/insertData';
import { message } from 'ant-design-vue';
// actions
export const actions = {
  setEditingElement({ commit }, payload) {
    commit('setEditingElement', payload);
    payload && window.getEditorApp.$emit('setEditingElement', payload);
  },
  async setElementPosition({ commit, state }, payload) {
    const eleIdObj = {
      id: state.editingElement.uuid,
      slideId: state.editingElement.slideId,
      pptId: state.editingElement.pptId,
      type:state.editingElement?.pluginProps?.areaType
    }
    if(state.editingElement.pluginProps.areaType==='effectPic'&&state.editingPage.slideType===0) {
      message.error('效果图只能添加在空间详情页面，请重新编辑')
      return;
    }
    const { success, result } = await elementApi.slideWrapUpdateSlideElement({ ...payload, ...eleIdObj }, state.editingElement.name)
    success && commit('setElementCommonStyle', payload);
  },
  async setElementCommonStyle({ commit, state }, payload) {
    const eleIdObj = {
      id: state.editingElement.uuid,
      slideId: state.editingElement.slideId,
      pptId: state.editingElement.pptId,
      type:state.editingElement?.pluginProps?.areaType
    }
    if(state.editingElement.pluginProps.areaType==='effectPic'&&state.editingPage.slideType===0) {
      message.error('效果图只能添加在空间详情页面，请重新编辑')
      return;
    }
    const { success, result } = await elementApi.slideWrapUpdateSlideElement({ ...payload, ...eleIdObj }, state.editingElement.name)
    success && commit('setElementCommonStyle', payload);
  },
  async setElementPluginPropsText({ commit, state }, { eleIdObj, payload }) {
    const newPayload = JSON.parse(JSON.stringify(payload))
    if (payload.content) {
      payload.content = rgb2hex(payload.content)
      newPayload.content = sty2abbr(rgb2hex(payload.content))
    }
    const { success, result } = await elementApi.slideWrapUpdateSlideElement({ ...newPayload, ...eleIdObj }, eleIdObj.name)
    // success && commit('setElementPluginProps', payload);

  },
  async setElementPluginProps({ commit, state }, payload) {
    const eleIdObj = {
      id: state.editingElement.uuid,
      slideId: state.editingElement.slideId,
      pptId: state.editingElement.pptId,
      isFixed: 0
    }
    const newPayload = JSON.parse(JSON.stringify(payload))
    if (payload.content) {
      payload.content = rgb2hex(payload.content)
      newPayload.content = sty2abbr(rgb2hex(payload.content))
    }
    if (payload.textStyle) {
      eleIdObj.type = state.editingElement?.pluginProps?.areaType;
      payload.textStyle = rgb2hex(payload.textStyle)
      newPayload.textStyle = sty2abbr(rgb2hex(payload.textStyle))
    }
    if(payload.extraIdTwo){
      newPayload.extraIdTwo = payload.extraIdThree?`${payload.extraIdTwo}|${payload.extraIdThree}`:payload.extraIdTwo
    }
    delete newPayload.sentenceList
    const { success, result } = await elementApi.slideWrapUpdateSlideElement({ ...newPayload, ...eleIdObj }, state.editingElement.name)
    success && commit('setElementPluginProps', payload);
  },
  setElementShape({ commit }, payload) {
    commit('setElementCommonStyle', payload);
  },
  recordElementRect({ commit }, payload = {}) {
    commit('recordRect', payload);
  },
  async elementManager({ dispatch, commit, state }, { type, value }) {
    const { editingPage, editingElement } = state;
    switch (type) {
      case 'add':
        value.pptId = editingPage.pptId
        value.slideId = editingPage.uuid
        const newCommonStyle = eleRelativeBox({ width: value.box.width, height: value.box.height }, { width: value.commonStyle.width, height: value.commonStyle.height })
        value.commonStyle.width = newCommonStyle.width
        value.commonStyle.height = newCommonStyle.height
        value.commonStyle.top = value.commonStyle.top!==undefined? value.commonStyle.top : newCommonStyle.top
        value.commonStyle.left = value.commonStyle.left!==undefined? value.commonStyle.left : newCommonStyle.left
        let asyncParam = {
          pptId: value.pptId,
          slideId: value.slideId,
          width: value.commonStyle.width,
          height: value.commonStyle.height,
          left: value.commonStyle.left,
          top: value.commonStyle.top,
          zIndex: editingPage.elements.length,
        }
        let resAdd
        if (value.name == 'ppt-text') {
          asyncParam.content = sty2abbr(value.pluginProps.content)
          resAdd = await elementApi.slideWrapCreateSlideText(asyncParam)
        } else if (value.name == 'ppt-picture') {
          asyncParam.imagePath = value.pluginProps.imagePath
          resAdd = await elementApi.slideWrapCreateSlideImage(asyncParam)
        } else {
          asyncParam.contentType = value.shortcutProps.contentType
          asyncParam.contentName = value.shortcutProps.contentName
          asyncParam.type = value.shortcutProps.areaType
          if(value.shortcutProps.textStyle) asyncParam.textStyle = sty2abbr(value.shortcutProps.textStyle)
          if( value.shortcutProps.areaType==='sentence') {
            asyncParam.extraIdTwo = value.shortcutProps.extraIdThree?`${value.shortcutProps.extraIdTwo}|${value.shortcutProps.extraIdThree}`:value.shortcutProps.extraIdThree
            asyncParam.extraId = value.shortcutProps.extraId
          }
          resAdd = await elementApi.slideWrapCreateSlideArea(asyncParam)
        }
        if (resAdd && resAdd.success) {
          value.uuid = resAdd.result.id
          commit('elementManager', { type, value });
        }
        break;
      case 'delete':
        const elementTypeMap = new Map([
          ['ppt-text', 'text'],
          ['ppt-picture', 'image'],
          ['ppt-table', 'table'],
          ['ppt-area', 'area']
        ])
        const elementType = elementTypeMap.has(editingElement.name) ? elementTypeMap.get(editingElement.name) : elementTypeMap.get('ppt-area');
        console.log('editingElement', editingElement);
        const res = await elementApi.slideWrapDelSlideInfo({
          pptId: editingElement.pptId,
          slideId: editingElement.slideId,
          id: editingElement.uuid,
          type: elementType,
          groupId: editingElement.name === 'ppt-table' ? editingElement.groupId : undefined,
        })
        res.success && commit('elementManager', { type: 'delete' });
        editingPage.elements.length > 1 && dispatch('elementManager', { type: 'resetAll' })//删除成功之后，重新排序 ；因为删除本地数据已经排序，所以不需要做本地排序，只需要异步排序
        break;
      default:
        commit('elementManager', { type: type });
        const slideInfoResults = [];
        const elements = JSON.parse(JSON.stringify(editingPage.elements));
        elements.forEach((item, index) => {
          if (index === 0) return;
          const elementTypeMap = new Map([
            ['ppt-text', 'text'],
            ['ppt-picture', 'image'],
            ['ppt-table', 'table'],
            ['ppt-area', 'area']
          ])
          const elementType = elementTypeMap.has(item.name) ? elementTypeMap.get(item.name) : elementTypeMap.get('ppt-area');
          slideInfoResults.push({
            id: item.uuid,
            sort: index,
            type: elementType,
          });
        });
        if(state.editingElement.pluginProps.areaType==='effectPic'&&state.editingPage.slideType===0) {
          message.error('效果图只能添加在空间详情页面，请重新编辑')
          return;
        }
        await elementApi.slideWrapSlideInfoSort({
          pptId: state.editingPage.pptId,
          slideId: state.editingPage.uuid,
          slideInfoResults
        })
    }
  },
  // 设置默认背景和颜色
  async pptWrapSetSlideBackground({ commit, state }, payload) { // eslint-disable-line
    const workObj = {
      id: state.work.id
    }
    const resp = await elementApi.pptWrapSetSlideBackground({ ...payload, ...workObj });
    return resp;
  },
  clearPreviewElements({ commit, state }) {
    const { pages } = state.work;
    const copyPages = JSON.parse(JSON.stringify(pages));
    copyPages.forEach((items, idxs) => {
      items.elements.forEach(item => {
        if (item.pluginProps.previewMode) {
          state.editingElement = item;
          commit('setEditingPage', idxs);
          commit('elementManager', { type: 'delete' });
        }
      })
    })
    state.previewSaveElement.forEach(item => {
      commit('setEditingPage', item.pluginProps.editingPage);
      commit('elementManager', {
        type: 'add',
        value: {
          name: 'ppt-text-template',
          shortcutProps: {
            contentType: item.pluginProps.contentType,
            contentName: item.pluginProps.contentName,
            areaType: item.pluginProps.areaType,
            textStyle: item.pluginProps.textStyle
          },
          box: {
            width: state.work.width,
            height: state.work.height
          },
          commonStyle: {
            width: item.commonStyle.width,
            height: item.commonStyle.height,
            top: item.commonStyle.top,
            left: item.commonStyle.left
          },
          uuid: item.uuid,
          slideId: item.slideId,
          pptId: item.pptId
        }
      })
    })
    commit('setEditingPage', state.editingPageIndex);
  },
  setPreviewElements({ commit, state }) {
    const { pages } = state.work;
    const { isTemplate } = state.work;
    if (isTemplate !== 0) {
      const copyPages = JSON.parse(JSON.stringify(pages));
      state.previewSaveElement = [];
      copyPages.forEach((items, idxs) => {
        commit('setEditingPage', idxs);
        items.elements.forEach(item => {
          if (item.pluginProps.areaType === 'text') {
            item.pluginProps.editingPage = idxs;
            state.previewSaveElement.push(item);
            state.editingElement = item;
            commit('elementManager', { type: 'delete' });
            let content = ''
            let contentName= `${item.pluginProps.contentName.split('-')[1]}：${insertData.previewMockData[item.pluginProps.contentType]}`
            if(item.pluginProps.textStyle) {
              content = item.pluginProps.textStyle.replace('%s',contentName)
            }else {
              content = `<p><span style="font-size:14px;color:#333333;">${contentName}</span></p>`
            }
            commit('elementManager', {
              type: 'add',
              value: {
                name: 'ppt-text',
                box: {
                  width: state.work.width,
                  height: state.work.height
                },
                pluginProps: {
                  content: content,
                  previewMode: 1
                },
                commonStyle: {
                  width: item.commonStyle.width,
                  height: item.commonStyle.height,
                  left: item.commonStyle.left,
                  top: item.commonStyle.top
                }
              }
            });
          }
        })
      })
      commit('setEditingPage', state.editingPageIndex);
    }
  },
  /**
   * 更新报价表格元素
   * @param {string} type:single, all
   */
  async updateSlideTableSchemeInfo({commit, state}, { type }) {
    const {
      quId: uuId,
      slideId,
      pptId,
      pluginProps: { areaContentType } } = state.editingElement;
    const params = {
      uuId: type === 'single' ? uuId : undefined,
      slideId,
      pptId,
      areaContentType
    }
    const res = await elementApi.updateSlideTableSchemeInfo(params);
    return res;
  },
};

// mutations
export const mutations = {
  setIsPreviewMode(state, payload) {
    state.isPreviewMode = payload;
  },
  setEditingElement(state, payload) {
    state.editingElement = payload;
  },
  setElementCommonStyle(state, payload) {
    state.editingElement.commonStyle = {
      ...state.editingElement.commonStyle,
      ...payload,
    };
  },
  setElementPluginProps(state, payload) {
    state.editingElement.pluginProps = {
      ...state.editingElement.pluginProps,
      ...payload,
    };
  },
  elementManager(state, { type, value }) {
    const { editingPage, editingElement } = state;
    const { elements } = editingPage;
    const len = elements.length;
    switch (type) {
      case 'add':
        const vm = getVM(value.name);
        vm.$options.shortcutProps = value.shortcutProps;
        // 用于拖拽结束，确定最终放置的位置
        vm.$options.dragStyle = value.dragStyle; // {left: Number, top: Number}
        vm.$options.pptId = value.pptId;
        vm.$options.slideId = value.slideId;
        vm.$options.uuid = value.uuid;
        vm.$options.pluginProps = value.pluginProps
        vm.$options.commonStyle = value.commonStyle
        const element = new Element(vm.$options);
        elements.push(element);
        // 新增后选中新增元素
        state.editingElement = element;
        break;
      case 'delete':
        {
          const index = elements.findIndex(e => e.uuid === editingElement.uuid);
          if (index !== -1) {
            // let newElements = elements.slice()
            // newElements.splice(index, 1)
            // state.editingPage.elements = newElements
            state.editingPage.elements.splice(index, 1);
            // 删除表格，同时把对应的图片删除
            if (editingElement.name === 'ppt-table') {
              function cb() {
                elements.some((item, index) => {
                  if (editingElement.groupId === item.groupId) {
                    state.editingPage.elements.splice(index, 1);
                    cb();
                  }
                })
              }
              cb();
            }
          }
          state.editingElement = null;
        }
        break;
      case 'move2Top':
        {
          let index = elements.findIndex(e => e.uuid === editingElement.uuid);
          if (index + 1 != len) {
            //首先判断当前元素需要上移几个位置,置底移动到数组的第一位
            var moveNum = len - 1 - index;
            //循环出需要一个一个上移的次数
            for (var i = 0; i < moveNum; i++) {
              const res = swapArray(elements, index, index + 1);
              index++;
            }
          }
        }
        break;
      case 'move2Bottom':
        {
          let index = elements.findIndex(e => e.uuid === editingElement.uuid);
          if (index != 1) {
            //首先判断当前元素需要上移几个位置,置底移动到数组的第一位 1指去掉背景元素的位置
            var moveNum = index - 1;
            //循环出需要一个一个上移的次数
            for (var i = 0; i < moveNum; i++) {
              swapArray(elements, index, index - 1);
              index--;
            }
          }
        }
        break;
      case 'addZindex':
        {
          const index = elements.findIndex(e => e.uuid === editingElement.uuid);
          if (index + 1 != len) {
            swapArray(elements, index, index + 1);
          }
        }
        break;
      case 'minusZindex':
        {
          const index = elements.findIndex(e => e.uuid === editingElement.uuid);
          if (index != 1) {
            swapArray(elements, index, index - 1);
          }
        }
        break
      default:
    }
  },
  recordRect(state, { type, value }) {
  },
};